import React from "react";

import { ItemText, MenuListItem } from "../MultiLevelMenu";
import { searchTabProp } from "../utilities";

const RentBuySellMenu = () => (
  <>
    <MenuListItem isFullSize>
      <ItemText href="/" isBig {...searchTabProp("rentals", "/")}>
        Rent
      </ItemText>
    </MenuListItem>
    <MenuListItem isFullSize>
      <ItemText href="/" isBig {...searchTabProp("sales", "/")}>
        Buy
      </ItemText>
    </MenuListItem>
    <MenuListItem isFullSize isNew>
      <ItemText aria-label="Sell Your Home" href="/sell-your-home" isBig>
        Sell
      </ItemText>
    </MenuListItem>
  </>
);

RentBuySellMenu.propTypes = {};

RentBuySellMenu.defaultProps = {};

export default RentBuySellMenu;
